const isProduction = process.env.NODE_ENV === 'production'

export const REACT_APP_URL = isProduction ? process.env.REACT_APP_URL : process.env.REACT_APP_LOCAL_URL// "http://34.130.219.231:8001/"
export const REACT_APP_WORKING_URL = isProduction ? process.env.REACT_APP_WORKING_URL : process.env.REACT_APP_LOCALHOST_URL// "http://34.130.219.231:8001/"
export const REACT_APP_GOOGLE_OAUTH_ID = process.env.REACT_APP_GOOGLE_OAUTH_ID // "903686914685-aq99ktd76ps9ulp0361uroepd6dghrit.apps.googleusercontent.com"
export const REACT_APP_WORKING_CHATAPI_URL = isProduction ? process.env.REACT_APP_WORKING_CHATAPI_URL : process.env.REACT_APP_LOCALHOST_CHATAPI_URL// "http://34.130.219.231:8000/"



export const CHATBOT_BACKEND_URL = process.env.REACT_APP_CHATBOT_BACKEND_URL
export const ALI_WEB_APY = process.env.REACT_APP_ALI_WEB_APY
export const MER_CODE = process.env.REACT_APP_MER_CODE
export const MERCHANT_ID = process.env.REACT_APP_MERCHANT_ID
export const OPER_ID = process.env.REACT_APP_OPER_ID
export const SUBMIT_TYPE = process.env.REACT_APP_SUBMIT_TYPE


